import { Gift } from "lucide-react";

const MAX_MSG = 160;

export default function GiftWrapToggle({ checked, onChange, message = "", onMessage, prefix = "checkout" }) {
  return (
    <div className={`mt-5 rounded-lg border p-4 transition-colors ${checked ? "border-[#E85D8A] bg-[#FCE4EC]/60" : "border-[#E8E2D9] bg-white hover:border-[#d9cfb6]"}`} data-testid={`${prefix}-giftwrap-box`}>
      <label className="flex cursor-pointer items-start gap-3" data-testid={`${prefix}-giftwrap-label`}>
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={`${prefix}-giftwrap-checkbox`} className="mt-1 h-4 w-4 accent-[#E85D8A]" />
        <span className="flex-1 text-sm">
          <span className="flex items-center gap-2 font-semibold"><Gift className={`h-4 w-4 ${checked ? "text-[#E85D8A]" : "text-[#8C8498]"}`} />Gift wrap it <span className="ml-auto text-xs font-medium text-[#4F7A5C]">Free</span></span>
          <span className="mt-0.5 block text-xs text-[#5E5868]">Wrapped in kraft paper with a ribbon, no price slip inside — ready to hand over.</span>
        </span>
      </label>
      {checked && onMessage && (
        <div className="mt-3 pl-7">
          <label htmlFor={`${prefix}-giftmsg`} className="text-xs font-semibold text-[#26232E]">Card message <span className="font-normal text-[#8C8498]">(optional — we'll handwrite it on the gift card)</span></label>
          <textarea id={`${prefix}-giftmsg`} value={message} onChange={(e) => onMessage(e.target.value.slice(0, MAX_MSG))} rows={2} maxLength={MAX_MSG} data-testid={`${prefix}-giftwrap-message`}
            placeholder="e.g. Happy 30th, Priya! Here's to all our mad adventures — love, Rohan" className="mt-1.5 w-full resize-none rounded-md border border-[#F3C4D4] bg-white px-3 py-2 text-sm leading-snug outline-none focus:border-[#E85D8A]" />
          <p className="mt-1 text-right font-mono text-[10px] text-[#8C8498]" data-testid={`${prefix}-giftwrap-message-count`}>{message.length}/{MAX_MSG}</p>
        </div>
      )}
    </div>
  );
}
